
<template>
    <button
        shape="circle"
        type="button"
        class="support-chat-button" data-open="false"
        @click="toggleZD"
    >
        <svg
            position="right"
            class="open-icon"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <path
                d="M10,18 L6,22 L6,18 L10,18 Z M17,6 C19.7614237,6 22,8.23857625 22,11 C22,13.7614237 19.7614237,16 17,16 L17,16 L7,16 C4.23857625,16 2,13.7614237 2,11 C2,8.23857625 4.23857625,6 7,6 L7,6 Z"
                transform="translate(12.000000, 14.000000) scale(-1, 1) translate(-12.000000, -14.000000) "
            ></path>
        </svg>

        <svg
            class="close-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="13"
            viewBox="0 0 21 13"
            focusable="false"
            role="presentation"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="currentColor"
                d="M20.1005 2.7169L10.9931 11.8244C10.4724 12.3451 9.62815 12.3451 9.10745 11.8244L-8.00829e-06 2.7169L1.88561 0.831278L10.0503 8.99593L18.2149 0.831278L20.1005 2.7169Z"
            ></path>
        </svg>
    </button>
</template>
<script>
import Vue from 'vue'

export default {
    name: "ZendeskWidgetButton",
    data: () => ({
        isOpen: false,
    }),
    created() {
        // this.$zendesk.on('loaded', () => {
        //     console.log('Zendesk widget loaded');
        // });
        // this.$zendesk.on('opened', () => {
        //     console.log('Zendesk widget opened');
        // });
        // this.$zendesk.on('closed', () => {
        //     console.log('Zendesk widget closed');
        // })
    },
    methods: {
        toggleZD() {
            // this.isOpen = !this.isOpen;
            // if (this.isOpen)
                this.$zendesk.zE('messenger', 'open');
            // else
            //     this.$zendesk.zE('messenger', 'close');
        }
    }
}
</script>

<style scoped lang="scss">
.support-chat-button:hover {
    cursor: pointer;
}
.support-chat-button {
    position:fixed;
    bottom:10px;
    right:10px;
    color: white;
    fill: white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    box-shadow: rgba(36, 36, 36, 0.15) 0px 20px 30px 0px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    background-color: rgb(44, 112, 179) !important;
    border: none;
}

.support-chat-button[data-open="false"] .close-icon {
    display: none;
}

.support-chat-button[data-open="true"] .open-icon {
    display: none;
}
</style>